import React from "react";
import { Button, MessageBanner, Modal, ModalFooter, } from "@folio/stripes/components";
import { FormattedMessage, useIntl } from "react-intl";
export var BulkSubscribePeriodicalsDialog = function (_a) {
    var open = _a.open, selectedCount = _a.selectedCount, onClose = _a.onClose, onSubmit = _a.onSubmit, _b = _a.isLoading, isLoading = _b === void 0 ? false : _b;
    var formatMessage = useIntl().formatMessage;
    return (React.createElement(Modal, { open: open, label: formatMessage({
            id: "ui-br-legaldeposits.periodicals.bulk.subscribe.title",
        }), onClose: onClose, size: "small", footer: React.createElement(ModalFooter, null,
            React.createElement(Button, { buttonStyle: "primary", onClick: onSubmit, disabled: selectedCount === 0 || isLoading },
                React.createElement(FormattedMessage, { id: "ui-br-legaldeposits.button.confirm" })),
            React.createElement(Button, { onClick: onClose },
                React.createElement(FormattedMessage, { id: "ui-br-legaldeposits.button.cancel" }))) },
        React.createElement(MessageBanner, { type: "warning" },
            React.createElement(FormattedMessage, { id: "ui-br-legaldeposits.periodicals.bulk.subscribe.summary", values: { count: selectedCount } }))));
};
